const MessageWrapper: React.FC<{ className?: string }> = ({ className, children }) => {
    return <div className={className}>{children}</div>;
};

export default MessageWrapper;
